function r(r){if(function(){try{return!(!window.CSS||!window.CSS.supports)&&window.CSS.supports("color","var(--fake-var)")}catch(r){return!1}}())return"var(--".concat(r,")")}export{r as getCSSVar};
//# sourceMappingURL=themes.js.map
